import {
  MdAdd,
  MdSearch,
} from "react-icons/md";

import "./CateringToolbar.css";

function CateringToolbar({
  search,
  onSearch,

  category,
  onCategoryChange,

  onAdd,
}) {
  return (
    <div className="catering-toolbar">

      <div className="catering-toolbar-left">

        <div className="catering-search">

          <MdSearch className="search-icon" />

          <input
            type="text"
            placeholder="Search Packages..."
            value={search}
            onChange={(e) =>
              onSearch(e.target.value)
            }
          />

        </div>

        <select
          value={category}
          onChange={(e) =>
            onCategoryChange(e.target.value)
          }
        >
          <option value="All">
            All Categories
          </option>

          <option value="Wedding">
            Wedding
          </option>

          <option value="Birthday">
            Birthday
          </option>

          <option value="Corporate">
            Corporate
          </option>

          <option value="Festival">
            Festival
          </option>

          <option value="Housewarming">
            Housewarming
          </option>

          <option value="Custom">
            Custom
          </option>

        </select>

      </div>

      <button
        className="add-package-btn"
        onClick={onAdd}
      >
        <MdAdd />

        Add Package
      </button>

    </div>
  );
}

export default CateringToolbar;